import { z } from 'zod'

export const SubscriberIdSchema = z
  .string()
  .uuid('Must provide a valid subscriber ID')
  .brand('SubscriberId')

export type SubscriberId = z.infer<typeof SubscriberIdSchema>
